import React from "react";
import { Button } from "@clarkinc/zest-design-system";

interface Props {
  link: string;
  manufacturerItemNumberDisplayText: string;
}

const ReplacementsAd = ({ link, manufacturerItemNumberDisplayText }: Props) => {
  return (
    <a data-testid="compatible-with-link" href={link}>
      <div className="side-section">
        <div className="bg-gray-800 p-6 flex flex-col gap-4 m-[7px] xs:mx-0 xs:mt-0 xs:mb-5 text-white border-gray-200 border rounded">
          <div className="flex gap-4">
            <div>
              <svg
                width="88"
                height="88"
                viewBox="0 0 88 88"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g clipPath="url(#clip0_4805_42458)">
                  <circle
                    cx="43.2364"
                    cy="46.7589"
                    r="34.5697"
                    fill="#EEF0ED"
                  />
                  <path
                    d="M32.5725 64.1193L25.5592 75.4311H11.5326L4.51929 64.1193L11.5326 52.8076L25.5592 52.8076L32.5725 64.1193Z"
                    fill="#BCC3B6"
                  />
                  <mask id="path-3-inside-1_4805_42458" fill="white">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M27.5756 75.9405L34.6454 63.6951L27.5756 51.4498H13.4358L6.36597 63.6951L13.4358 75.9405H27.5756ZM20.5059 68.8702C23.3172 68.8702 25.5962 66.5912 25.5962 63.7799C25.5962 60.9686 23.3172 58.6896 20.5059 58.6896C17.6946 58.6896 15.4156 60.9686 15.4156 63.7799C15.4156 66.5912 17.6946 68.8702 20.5059 68.8702Z"
                    />
                  </mask>
                  <path
                    d="M34.6454 63.6951L35.9742 64.4623L36.4172 63.6951L35.9742 62.9279L34.6454 63.6951ZM27.5756 75.9405V77.4749H28.4614L28.9044 76.7077L27.5756 75.9405ZM27.5756 51.4498L28.9044 50.6826L28.4614 49.9154H27.5756V51.4498ZM13.4358 51.4498V49.9154H12.55L12.107 50.6826L13.4358 51.4498ZM6.36597 63.6951L5.03715 62.9279L4.59422 63.6951L5.03715 64.4623L6.36597 63.6951ZM13.4358 75.9405L12.107 76.7077L12.55 77.4749H13.4358V75.9405ZM33.3166 62.9279L26.2468 75.1733L28.9044 76.7077L35.9742 64.4623L33.3166 62.9279ZM26.2468 52.217L33.3166 64.4623L35.9742 62.9279L28.9044 50.6826L26.2468 52.217ZM13.4358 52.9841H27.5756V49.9154H13.4358V52.9841ZM7.69478 64.4623L14.7646 52.217L12.107 50.6826L5.03715 62.9279L7.69478 64.4623ZM14.7646 75.1733L7.69478 62.9279L5.03715 64.4623L12.107 76.7077L14.7646 75.1733ZM27.5756 74.4061H13.4358V77.4749H27.5756V74.4061ZM24.0619 63.7799C24.0619 65.7437 22.4698 67.3358 20.5059 67.3358L20.5059 70.4046C24.1646 70.4046 27.1306 67.4386 27.1306 63.7799H24.0619ZM20.5059 60.2239C22.4698 60.2239 24.0619 61.816 24.0619 63.7799H27.1306C27.1306 60.1212 24.1646 57.1552 20.5059 57.1552V60.2239ZM16.95 63.7799C16.95 61.816 18.542 60.2239 20.5059 60.2239V57.1552C16.8472 57.1552 13.8812 60.1212 13.8812 63.7799H16.95ZM20.5059 67.3358C18.542 67.3358 16.95 65.7437 16.95 63.7799H13.8812C13.8812 67.4386 16.8472 70.4046 20.5059 70.4046L20.5059 67.3358Z"
                    fill="#272C25"
                    mask="url(#path-3-inside-1_4805_42458)"
                  />
                  <circle cx="20.5051" cy="63.7798" r="5.0903" fill="white" />
                  <circle
                    cx="33.7863"
                    cy="20.7958"
                    r="16.3726"
                    transform="rotate(-30 33.7863 20.7958)"
                    fill="#BCC3B6"
                  />
                  <circle
                    cx="63.0085"
                    cy="71.4094"
                    r="16.3726"
                    transform="rotate(-30 63.0085 71.4094)"
                    fill="#BCC3B6"
                  />
                  <rect
                    x="27.249"
                    y="24.8092"
                    width="14.9219"
                    height="57.2005"
                    transform="rotate(-30 27.249 24.8092)"
                    fill="#BCC3B6"
                  />
                  <mask id="path-9-inside-2_4805_42458" fill="white">
                    <path
                      fillRule="evenodd"
                      clipRule="evenodd"
                      d="M50.4818 11.158C53.7005 16.733 53.2679 23.414 49.926 28.4321L64.466 53.6161C70.4829 53.2307 76.4855 56.1966 79.7043 61.7717C84.2255 69.6026 81.5424 79.616 73.7115 84.1372C65.8806 88.6583 55.8672 85.9753 51.3461 78.1444C48.2102 72.7129 48.5401 66.2316 51.6496 61.2611L36.8973 35.7094C31.0378 35.9173 25.2595 32.9623 22.1236 27.5307C17.6024 19.6998 20.2855 9.68643 28.1164 5.16525C35.9473 0.644079 45.9606 3.32714 50.4818 11.158ZM32.5536 26.1403L40.193 26.1403L44.0127 19.5243L40.193 12.9084L32.5536 12.9084L28.7339 19.5243L32.5536 26.1403ZM69.5238 76.4374L61.8844 76.4374L58.0647 69.8215L61.8844 63.2056L69.5239 63.2056L73.3435 69.8215L69.5238 76.4374Z"
                    />
                  </mask>
                  <path
                    d="M49.926 28.4321L48.6489 27.5816L48.1209 28.3743L48.5972 29.1992L49.926 28.4321ZM64.466 53.6161L63.1372 54.3833L63.6135 55.2082L64.5641 55.1473L64.466 53.6161ZM51.6496 61.2611L52.9504 62.0749L53.4396 61.2928L52.9784 60.4939L51.6496 61.2611ZM36.8973 35.7094L38.2261 34.9423L37.7649 34.1433L36.8429 34.176L36.8973 35.7094ZM40.193 26.1403L40.193 27.6746L41.0789 27.6746L41.5218 26.9075L40.193 26.1403ZM32.5536 26.1403L31.2248 26.9075L31.6678 27.6746L32.5536 27.6746L32.5536 26.1403ZM44.0127 19.5243L45.3415 20.2915L45.7845 19.5243L45.3415 18.7572L44.0127 19.5243ZM40.193 12.9084L41.5218 12.1412L41.0789 11.3741L40.193 11.3741L40.193 12.9084ZM32.5536 12.9084L32.5536 11.3741L31.6678 11.3741L31.2248 12.1412L32.5536 12.9084ZM28.7339 19.5243L27.4051 18.7572L26.9622 19.5243L27.4051 20.2915L28.7339 19.5243ZM61.8844 76.4374L60.5556 77.2046L60.9986 77.9718L61.8844 77.9718L61.8844 76.4374ZM69.5238 76.4374L69.5238 77.9718L70.4097 77.9718L70.8527 77.2046L69.5238 76.4374ZM58.0647 69.8215L56.7359 69.0543L56.293 69.8215L56.7359 70.5887L58.0647 69.8215ZM61.8844 63.2056L61.8845 61.6712L60.9986 61.6712L60.5556 62.4384L61.8844 63.2056ZM69.5239 63.2056L70.8527 62.4384L70.4097 61.6712L69.5239 61.6712L69.5239 63.2056ZM73.3435 69.8215L74.6724 70.5887L75.1153 69.8215L74.6724 69.0543L73.3435 69.8215ZM51.2031 29.2826C54.8559 23.7977 55.332 16.4902 51.8106 10.3909L49.153 11.9252C52.0689 16.9758 51.6799 23.0303 48.6489 27.5816L51.2031 29.2826ZM65.7948 52.8489L51.2548 27.6649L48.5972 29.1992L63.1372 54.3833L65.7948 52.8489ZM81.0331 61.0046C77.5115 54.905 70.9446 51.6636 64.3679 52.0848L64.5641 55.1473C70.0212 54.7978 75.4594 57.4882 78.3755 62.5389L81.0331 61.0046ZM74.4787 85.466C83.0435 80.5211 85.978 69.5693 81.0331 61.0046L78.3755 62.5389C82.4729 69.636 80.0413 78.7109 72.9443 82.8083L74.4787 85.466ZM50.0173 78.9116C54.9621 87.4763 65.9139 90.4108 74.4787 85.466L72.9443 82.8083C65.8473 86.9058 56.7724 84.4742 52.6749 77.3772L50.0173 78.9116ZM50.3488 60.4473C46.9502 65.8799 46.5865 72.9693 50.0173 78.9116L52.6749 77.3772C49.834 72.4566 50.13 66.5833 52.9504 62.0749L50.3488 60.4473ZM35.5685 36.4766L50.3208 62.0283L52.9784 60.4939L38.2261 34.9423L35.5685 36.4766ZM20.7948 28.2979C24.2257 34.2404 30.5474 37.47 36.9517 37.2429L36.8429 34.176C31.5281 34.3646 26.2934 31.6842 23.4524 26.7635L20.7948 28.2979ZM27.3492 3.83644C18.7844 8.78132 15.8499 19.7331 20.7948 28.2979L23.4524 26.7635C19.3549 19.6665 21.7865 10.5915 28.8836 6.49406L27.3492 3.83644ZM51.8106 10.3909C46.8657 1.82607 35.914 -1.10844 27.3492 3.83644L28.8836 6.49406C35.9806 2.3966 45.0555 4.82822 49.153 11.9252L51.8106 10.3909ZM40.193 24.6059L32.5536 24.6059L32.5536 27.6746L40.193 27.6746L40.193 24.6059ZM42.6839 18.7572L38.8642 25.3731L41.5218 26.9075L45.3415 20.2915L42.6839 18.7572ZM38.8642 13.6756L42.6839 20.2915L45.3415 18.7572L41.5218 12.1412L38.8642 13.6756ZM32.5536 14.4428L40.193 14.4428L40.193 11.3741L32.5536 11.3741L32.5536 14.4428ZM30.0627 20.2915L33.8824 13.6756L31.2248 12.1412L27.4051 18.7572L30.0627 20.2915ZM33.8824 25.3731L30.0627 18.7572L27.4051 20.2915L31.2248 26.9075L33.8824 25.3731ZM61.8844 77.9718L69.5238 77.9718L69.5238 74.903L61.8844 74.903L61.8844 77.9718ZM56.7359 70.5887L60.5556 77.2046L63.2133 75.6702L59.3936 69.0543L56.7359 70.5887ZM60.5556 62.4384L56.7359 69.0543L59.3936 70.5887L63.2133 63.9728L60.5556 62.4384ZM69.5239 61.6712L61.8845 61.6712L61.8844 64.7399L69.5239 64.7399L69.5239 61.6712ZM74.6724 69.0543L70.8527 62.4384L68.195 63.9728L72.0147 70.5887L74.6724 69.0543ZM70.8527 77.2046L74.6724 70.5887L72.0147 69.0543L68.195 75.6702L70.8527 77.2046Z"
                    fill="#272C25"
                    mask="url(#path-9-inside-2_4805_42458)"
                  />
                  <path
                    d="M40.3002 26.3027L32.4295 26.3166L28.5061 19.5212L32.4535 12.7119L40.3242 12.6981L44.2475 19.4934L40.3002 26.3027Z"
                    fill="white"
                  />
                  <path
                    d="M69.4958 76.4538L61.8564 76.4538L58.0367 69.8379L61.8564 63.222L69.4958 63.222L73.3155 69.8379L69.4958 76.4538Z"
                    fill="white"
                  />
                </g>
                <defs>
                  <clipPath id="clip0_4805_42458">
                    <rect
                      width="88"
                      height="88"
                      fill="white"
                      transform="translate(0.200195 0.0600586)"
                    />
                  </clipPath>
                </defs>
              </svg>
            </div>

            <div className="flex gap-1 flex-col">
              <h2
                className="text-2xl leading-6 text-white font-bold m-0"
                style={{ textShadow: "none" }}
              >
                Need Parts &amp; Accessories?
              </h2>
              <h3
                className="font-normal text-sm leading-[17.5px] m-0 text-white whitespace-pre-wrap"
                style={{ textShadow: "none" }}
              >
                {manufacturerItemNumberDisplayText?.length ? "Show" : "Shop"}{" "}
                replacement parts and accessories for{" "}
                {manufacturerItemNumberDisplayText?.length
                  ? `\n${manufacturerItemNumberDisplayText} today!`
                  : "this item today!"}
              </h3>
            </div>
          </div>
          <Button
            className="w-full"
            size="medium"
            color="green"
            variant="green"
            theme="wss"
          >
            Find Parts for this Item
          </Button>
        </div>
      </div>
    </a>
  );
};

export default ReplacementsAd;
